import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import { DeNghiChuyenKhoModel, DeNghiChuyenKhoCTModel } from '../de-nghi-chuyen-kho-model/de-nghi-chuyen-kho.model';
const API_ROOT_URL = environment.ApiRoot + '/denghichuyenkho';
@Injectable()
export class DeNghiChuyenKhoService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DeNghiChuyenKho_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDeNghiChuyenKhoById(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/DeNghiChuyenKho_Detail?Id=${itemId}`, { headers: httpHeaders });
	}
	deleteDeNghiChuyenKho(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiChuyenKho_Delete?Id=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deleteDeNghiChuyenKhos(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '/deleteSelect';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders });
	}
	createDeNghiChuyenKho(item: DeNghiChuyenKhoModel): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		console.log(item);
		return this.http.post<any>(API_ROOT_URL + '/DeNghiChuyenKho_Insert', item, { headers: httpHeaders });
	}
	updateDeNghiChuyenKho(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiChuyenKhoModel>(API_ROOT_URL + '/DeNghiChuyenKho_Update', item, { headers: httpHeaders });
	}
	//#region ***filter***
	getFilterGroup(column: string, url: string): Observable<any> {
		return this.http.get<any>(environment.ApiRoot + url + `${column}`);
	}
	uploadFileDeNghiChuyenKho(data): Observable<any> {
		const url = API_ROOT_URL + '/DM_LoaiThanhPham_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	importDeNghiChuyenKho(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiChuyenKhoModel>(API_ROOT_URL + '/DM_LoaiThanhPham_Import', item, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/DownLoadFileImportMau`;
	}
	listPhongBanDeNghi(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + `/dungchung/CCTC_PB_List`;;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listHangHoaId(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + `/danhmuc/HHChung_List`;;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listKhoChuyen(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + `/danhmuc/KhoTonKho_List?idhh=${itemId}`;;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listKhoNhan(idkhochuyen: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + `/danhmuc/KhoNhan_List?IdKho=${idkhochuyen}`;;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	luuKetQuaDuyetDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiChuyenKhoCTModel>(API_ROOT_URL + '/LuuKetQuaDuyet', item, { headers: httpHeaders });
	}
	luuKetQuaDuyetAllDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiChuyenKhoCTModel>(API_ROOT_URL + '/LuuKetQuaDuyetAll', item, { headers: httpHeaders });
	}
	closeHangDeNghiCk(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiChuyenKhoModel>(API_ROOT_URL + '/CloseHangDeNghiCk', item, { headers: httpHeaders });
	}
	huyDeNghiChuyenKho(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiChuyenKho_Cancel?Id=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}

	cancelFullHangDeNghiCk(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/CloseFullHangDeNghiCk`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	getPhieuDeNghiChuyenKhoFromHH(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/GetPhieuDeNghiChuyenKhoFromHH?Id=${itemId}`, { headers: httpHeaders });
	}
	downloadExcel(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(API_ROOT_URL + '/DNCK_ExportExcel', {
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	  }
	
}
